// A stale tab lazy-loading a chunk that a new deploy removed fails with Vite's `vite:preloadError`.
// Reload once to self-heal, guarded by a sessionStorage timestamp so a still-failing reload can't loop.

const RELOAD_GUARD_MS = 10000;
const RELOAD_KEY = 'oqio:staleChunkReloadAt';

export const initStaleClientReload = () => {
  window.addEventListener('vite:preloadError', (event) => {
    let last = 0;
    try {
      last = Number(window.sessionStorage.getItem(RELOAD_KEY)) || 0;
    } catch {
      return; // no reliable guard -> let the error surface to Sentry
    }
    if (Date.now() - last < RELOAD_GUARD_MS) return; // reload didn't fix it -> stop

    try {
      window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    } catch {
      return;
    }
    event.preventDefault();
    window.location.reload();
  });
};
